import { Button } from "@touche-lts/panel-ui/dist";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { Department } from "models/departments";
import { useEffect } from "react";
import styles from "./footer.module.scss";
import cl from "classnames";

const FooterComponent = () => {
  const {
    routingStore: { push },
    departmentsStore: { getAllDepartments, allDepartments },
  } = useRootStore();

  useEffect(() => {
    getAllDepartments();
  }, [getAllDepartments]);

  return (
    <div className={styles.footerContainer}>
      <div className={cl(styles.footerContent)}>
        <div className="row">
          <div className="col-12">
            <h2>Shop by departments</h2>
          </div>
          <div
            className={cl(
              "col-12 col-lg-8",
              styles.departmentsContainer,
              styles.thinScroll,
            )}
          >
            {!allDepartments.length ? (
              <div>No departments availble</div>
            ) : (
              <div className="row mt-4">
                <div className="col-6 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(0, Math.ceil(allDepartments.length / 3))
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
                <div className="col-6 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(
                        Math.ceil(allDepartments.length / 3),
                        Math.ceil(allDepartments.length * (2 / 3)),
                      )
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
                <div className="col-12 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(
                        Math.ceil(allDepartments.length * (2 / 3)),
                        allDepartments.length - 1,
                      )
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
              </div>
            )}
          </div>
          <div className="col-12 col-lg-4">
            <div className={styles.footerContactUs}>
              <h2>Contact us</h2>
              <h4>Email</h4>
              <input type="text" placeholder="Email" />
              <h4>Message</h4>
              <textarea
                placeholder="Leave us a message..."
                cols={10}
                rows={10}
              ></textarea>
              <Button preset="primary">Send message</Button>
            </div>
          </div>
        </div>
        <hr className={styles.footerSeparationLine} />
        <div className={cl(styles.fooerCopyrightLinks, "row")}>
          <div className="col-12 col-lg-8">
            © Copyright {new Date().getFullYear()} Touch-E • All rights reserved
          </div>
          <div className="col-12 col-lg-4">
            <div className={styles.footerLinks}>
              {/* <a href="/terms">Terms & Conditions</a>
                            <a href="/privacy-policy">Privacy policy</a> */}
              <a href="/terms">All policies</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = observer(FooterComponent);
export { Footer };
